import { VisitConfidentialityLevelUpdateCommand } from '@dreryk/egabinet-visit-frontend-api';
import { ConfidentialityLevel } from '@dreryk/egabinet-medical-data-confidentiality-published-language-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

type UseVisitUpdateConfidentialityLevelCqrsCommandOptions = {
   visitId: number;
   onSuccess: VoidFunction;
};

export const useVisitUpdateConfidentialityLevelCqrsCommand = (
   options: UseVisitUpdateConfidentialityLevelCqrsCommandOptions
): UseCqrsCommandResult<void, ConfidentialityLevel> => {
   return useCqrsCommand<void, ConfidentialityLevel>(
      (confidentialityLevel) => {
         const command = new VisitConfidentialityLevelUpdateCommand();
         command.visitId = options.visitId;
         command.confidentialityLevel = confidentialityLevel;
         return command;
      },
      {
         onSuccess: () => {
            options.onSuccess();
         },
      }
   );
};
